import React, { useState, useEffect } from "react";
import axios from "axios";

import remoteImg from "../Asstes/Images/comp-remote.png";
import programImg1 from "../Asstes/Images/program-img-1.png";

const CompanyRemoteProgram = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [bannerData, setBannerData] = useState(null);
  const [contentData, setContentData] = useState([]);
  const [faqs, setFaqs] = useState([]);

  const [loadingBanner, setLoadingBanner] = useState(true);
  const [loadingContent, setLoadingContent] = useState(true);
  const [errorBanner, setErrorBanner] = useState(null);
  const [errorContent, setErrorContent] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  useEffect(() => {
    // Fetch banner
    axios
      .get(
        "/prosapiens-cms/public/api/banners/remote-program"
      )
      .then((res) => {
        if (res.data?.banners?.length > 0) {
          setBannerData(res.data.banners[0]);
        } else {
          setErrorBanner("No banner data found");
        }
      })
      .catch(() => setErrorBanner("Failed to fetch banner data"))
      .finally(() => setLoadingBanner(false));

    // Fetch content
    axios
      .get(
        "/prosapiens-cms/public/api/content/remote-program"
      )
      .then((res) => {
        if (res.data?.content?.length > 0) {
          setContentData(res.data.content);
        } else {
          setErrorContent("No content data found");
        }
      })
      .catch(() => setErrorContent("Failed to fetch content data"))
      .finally(() => setLoadingContent(false));

    // Fetch FAQs dynamically for "company-remote-program"
    axios
      .get("/prosapiens-cms/public/api/content/faqs")
      .then((res) => {
        if (res.data?.content?.length > 0) {
          const filtered = res.data.content
            .filter((item) => item.link_url === "company-remote-program")
            .sort((a, b) => Number(a.content_order) - Number(b.content_order))
            .map((item, index) => ({
              q: `${index + 1}. ${item.content_title}`,
              a: item.content_text.replace(/<\/?[^>]+(>|$)/g, ""),
            }));
          setFaqs(filtered);
        }
      })
      .catch((err) =>
        console.error("Error fetching company-remote-program FAQs:", err)
      );
  }, []);

  // Extract content by order
  const content1 = contentData.find((item) => item.content_order === "1");
  const content2 = contentData.find((item) => item.content_order === "2");
  const content3 = contentData.find((item) => item.content_order === "3");

  return (
    <>
      {/* Banner */}
      <div className="hire-section">
        <div className="container">
          <div className="hire-banner">
            <div className="image-container">
              <div className="text-side about" data-aos="fade-right">
                {loadingBanner && <p>Loading banner...</p>}
                {errorBanner && <p style={{ color: "red" }}>{errorBanner}</p>}
                {!loadingBanner && !errorBanner && bannerData && (
                  <>
                    <h2
                      dangerouslySetInnerHTML={{
                        __html: bannerData.banner_title.replace(
                          /\n/g,
                          "<br />"
                        ),
                      }}
                    />
                    <div
                      className="banner-content"
                      dangerouslySetInnerHTML={{
                        __html: bannerData.content_text,
                      }}
                    />
                    {bannerData.link_url && bannerData.link_url !== "#" ? (
                      <a href={bannerData.link_url} className="cta-yellow">
                        Hire Now →
                      </a>
                    ) : (
                      <a href="/contact" className="cta-yellow">
                        Hire Now →
                      </a>
                    )}
                  </>
                )}
              </div>
              <div className="image-side-about" data-aos="fade-left">
                <img src={remoteImg} alt="Office meeting" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* What We Do */}
      <section className="what-we-do">
        <div className="container">
          <div className="image-container">
            <div className="image-side" data-aos="fade-left">
              {loadingContent && <p>Loading content...</p>}
              {errorContent && <p style={{ color: "red" }}>{errorContent}</p>}
              {!loadingContent && !errorContent && content1?.content_image ? (
                <img
                  src={`/prosapiens-cms/public/${content1.content_image}`}
                  alt={content1.content_title || "Content Image"}
                />
              ) : (
                <img src={programImg1} alt="Fallback Image" />
              )}
            </div>
            <div className="text-side" data-aos="fade-right">
              {!loadingContent && !errorContent && content1 ? (
                <div
                  dangerouslySetInnerHTML={{ __html: content1.content_text }}
                />
              ) : (
                <>
                  <h2>
                    Ready to Build Your
                    <br />
                    Remote Dream Team?
                  </h2>
                  <p>
                    Experience stress-free hiring with ProSapiens. Our AI
                    selection process delivers pre-vetted candidates quickly.
                  </p>
                </>
              )}
              <a href="/contact" className="cta-yellow">
                Talk to Us →
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <div className="container">
        <div className="faq-wrapper">
          {/* <div className="faq-left"> -</div> */}
          <div className="faq-right">
            <h2>FAQ</h2>
            {faqs.length > 0 ? (
              faqs.map((faq, idx) => (
                <div className="faq-item" key={idx}>
                  <div
                    className={`faq-question${
                      activeIndex === idx ? " active" : ""
                    }`}
                    onClick={() => toggleFAQ(idx)}
                  >
                    {faq.q}
                    <span className="faq-icon">
                      {activeIndex === idx ? "–" : "+"}
                    </span>
                  </div>
                  <div
                    className={`faq-answer${
                      activeIndex === idx ? " active" : ""
                    }`}
                  >
                    {faq.a}
                  </div>
                </div>
              ))
            ) : (
              <p>No FAQs found for this page.</p>
            )}
          </div>
        </div>
      </div>

      {/* Features section */}
      <div className="container" data-aos="fade-up">
        {!loadingContent && !errorContent && content2 && (
          <div dangerouslySetInnerHTML={{ __html: content2.content_text }} />
        )}
      </div>

      {/* Hire Box */}
      <div className="container">
        {!loadingContent && !errorContent && content3 && (
          <div className="hire-box">
            <div dangerouslySetInnerHTML={{ __html: content3.content_text }} />
            <a href="/contact" className="cta-yellow">
              HIRE REMOTE TALENT NOW →
            </a>
          </div>
        )}
      </div>
    </>
  );
};

export default CompanyRemoteProgram;
